import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  fr: {
    // Navigation
    nav: {
      home: 'Accueil',
      optical: 'Optique',
      solar: 'Solaire',
      camera: 'Caméra',
      smart: 'Smart',
      more: 'Plus',
      technology: 'Technologie',
      reviews: 'Avis clients',
      about: 'À propos',
      faq: 'FAQ',
      blog: 'Blog',
      login: 'Connexion',
      pro: 'Pro',
      myProfile: 'Mon profil',
      myOrders: 'Mes commandes',
      adminDashboard: 'Admin Dashboard',
      logout: 'Se déconnecter',
      proAccount: 'Compte Professionnel',
      collection: 'La collection',
      contact: 'Contact',
    },
    // Banner
    banner: {
      connected: 'Toutes nos lunettes sont connectées',
      details: '— Bluetooth, app HeyCyan, IA embarquée',
      counterfeitTitle: 'Attention aux contrefaçons :',
      counterfeitText: "de nombreux produits imitant Joey Cyan circulent sur internet. Achetez uniquement sur ce site officiel pour garantir l'authenticité et votre sécurité.",
    },
    // Home page
    home: {
      leaderBadge: 'Leader en Chine · Désormais disponible en France',
      heroTitle1: 'Voyez le',
      heroTitle2: 'futur',
      heroTitle3: 'autrement.',
      heroDesc: 'Le produit n°1 en Chine arrive enfin en France. Joey Cyan, les lunettes connectées AR.',
      exploreCollection: 'Explorer la collection',
      discoverTech: 'Découvrir la tech',
      clients: 'Clients',
      rating: 'Note',
      china: 'Chine',
      countries: 'Pays',
      bestseller: 'Bestseller 2026',
      collectionTitle: 'Nos modèles phares',
      collectionLabel: 'Collection',
      seeAll: 'Voir tout',
      noProducts: "Aucun produit pour l'instant.",
      blueLight: 'Filtre lumière bleue',
      techTitle: "L'innovation à portée de vue",
      techLabel: 'Technologie',
      feat1Title: 'Connectivité totale',
      feat1Desc: 'Bluetooth 5.3 & WiFi 6E intégrés.',
      feat2Title: 'AR avancée',
      feat2Desc: 'Réalité augmentée ultra-précise.',
      feat3Title: "72h d'autonomie",
      feat3Desc: 'Batterie longue durée.',
      feat4Title: 'IA embarquée',
      feat4Desc: 'Traduction en temps réel.',
      testimonialsLabel: 'Témoignages',
      testimonialsTitle: 'Avis de nos clients',
      testimonialsRating: '4,5 / 5 · +8 743 clients',
      ctaLabel: 'Prêt à voir le monde autrement ?',
      ctaTitle: 'Découvrez notre collection',
      ctaDesc: 'Livraison offerte. Retours sous 14 Jours',
      ctaButton: 'Commander maintenant',
    },
    // Collection
    collection: {
      catalog: 'CATALOGUE',
      title: 'La Collection',
      all: 'Tous',
      search: 'Rechercher...',
      sortNew: 'Nouveautés',
      sortPriceAsc: 'Prix croissant',
      sortPriceDesc: 'Prix décroissant',
      sortNameAsc: 'Nom A-Z',
      noProducts: 'Aucun produit trouvé.',
      noProductsDesc: "Essayez de modifier vos critères de recherche.",
    },
    // Product detail
    product: {
      addToCart: 'Ajouter au panier',
      addedToCart: 'Ajouté au panier !',
      outOfStock: 'Rupture de stock',
      color: 'Couleur',
      lensOption: 'Configuration des verres',
      features: 'Caractéristiques',
      description: 'Description',
      reviews: 'Avis',
      new: 'NOUVEAU',
      bestseller: 'BESTSELLER',
      freeShipping: 'Livraison offerte',
      returns: 'Retours 14 jours',
      warranty: 'Garantie 2 ans',
      inStock: 'En stock',
      quantity: 'Quantité',
      proPrice: 'Prix Pro',
    },
    // Cart
    cart: {
      title: 'Votre panier',
      empty: 'Votre panier est vide',
      emptyDesc: 'Découvrez notre collection de lunettes connectées.',
      continueShopping: 'Continuer les achats',
      subtotal: 'Sous-total',
      shipping: 'Livraison',
      total: 'Total TTC',
      checkout: 'Passer commande',
      remove: 'Supprimer',
      freeShipping: 'Livraison offerte',
      promoCode: 'Code promo',
      apply: 'Appliquer',
      loginForCart: 'Connectez-vous pour sauvegarder votre panier',
    },
    // Login / Register
    auth: {
      loginTitle: 'Connexion',
      loginDesc: 'Accédez à votre compte Joey Cyan',
      email: 'Email',
      password: 'Mot de passe',
      loginButton: 'Se connecter',
      noAccount: 'Pas encore de compte ?',
      signUp: "S'inscrire",
      registerTitle: 'Créer un compte',
      registerDesc: 'Rejoignez la communauté Joey Cyan',
      name: 'Nom complet',
      confirmPassword: 'Confirmer le mot de passe',
      registerButton: "S'inscrire",
      hasAccount: 'Déjà un compte ?',
      loginLink: 'Se connecter',
      backToHome: "Retour à l'accueil",
      loginSuccess: 'Connexion réussie !',
      registerSuccess: 'Compte créé avec succès !',
      forgotPassword: 'Mot de passe oublié ?',
      forgotPasswordTitle: 'Mot de passe oublié',
      forgotPasswordDesc: 'Entrez votre email, nous vous enverrons un nouveau mot de passe.',
      forgotPasswordButton: 'Réinitialiser',
      forgotPasswordSuccess: 'Si un compte existe avec cet email, un nouveau mot de passe vous a été envoyé.',
      forgotPasswordBack: 'Retour à la connexion',
    },
    // Footer
    footer: {
      description: 'Les lunettes connectées nouvelle génération. Caméra, audio, IA embarquée pour voir le futur autrement.',
      shop: 'Boutique',
      opticalGlasses: 'Lunettes Optiques',
      solarGlasses: 'Lunettes Solaires',
      cameraAR: 'Caméra & AR',
      allCollection: 'Toute la collection',
      support: 'Support',
      returnsRefunds: 'Retours & Remboursements',
      salesConditions: 'Conditions de Vente',
      contact: 'Contact',
      blog: 'Blog',
      contactTitle: 'Contact',
      allRights: 'Tous droits réservés.',
      legalNotices: 'Mentions Légales',
      cgv: 'CGV',
      cgu: 'CGU',
      privacy: 'Confidentialité',
      cookies: 'Cookies',
      manageCookies: 'Gérer les cookies',
    },
    // FAQ
    faq: {
      title: 'Questions fréquentes',
      subtitle: 'Trouvez les réponses à vos questions sur nos lunettes connectées.',
      noFaq: 'Aucune FAQ disponible.',
      stillQuestions: 'Vous avez encore des questions ?',
      contactUs: 'Contactez-nous',
    },
    // Contact
    contact: {
      title: 'Contactez-nous',
      name: 'Nom',
      email: 'Email',
      subject: 'Sujet',
      message: 'Message',
      send: 'Envoyer',
      sending: 'Envoi...',
    },
    // Checkout
    checkout: {
      title: 'Commande',
      shipping: 'Livraison',
      payment: 'Paiement',
      summary: 'Récapitulatif',
      shippingAddress: 'Adresse de livraison',
      billingAddress: 'Adresse de facturation',
      differentBilling: 'Adresse de facturation différente',
      firstName: 'Prénom',
      lastName: 'Nom',
      address: 'Adresse',
      postalCode: 'Code postal',
      city: 'Ville',
      country: 'Pays',
      phone: 'Téléphone',
      shippingMethod: 'Mode de livraison',
      paymentMethod: 'Mode de paiement',
      placeOrder: 'Confirmer la commande',
    },
    // Cookie consent
    cookie: {
      title: 'Cookies & Vie privée',
      description: 'Nous utilisons des cookies pour améliorer votre expérience. Vous pouvez personnaliser vos préférences.',
      acceptAll: 'Accepter tout',
      reject: 'Refuser',
      customize: 'Personnaliser',
      learnMore: 'En savoir plus sur les cookies',
    },
    // Register
    register: {
      title: 'Créer un compte',
      subtitle: 'Rejoignez la communauté Joey Cyan',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      minChars: 'Min. 6 caractères',
      submit: 'Créer mon compte',
      hasAccount: 'Déjà un compte ?',
      login: 'Se connecter',
      backToHome: "Retour à l'accueil",
      success: 'Compte créé avec succès !',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    },
    // Product Detail
    productDetail: {
      backToCollection: 'Retour à la collection',
      notFound: 'Produit introuvable.',
      color: 'Coloris',
      lensConfig: 'Configuration des verres',
      notSelected: 'Non sélectionné',
      included: 'Inclus',
      reimbursed: '100% Remboursé',
      addToCart: 'Ajouter au panier',
      addedToCart: 'Ajouté au panier !',
      chooseLens: 'Veuillez choisir une option de verres',
      publicPrice: 'Prix public',
      proPrice: 'Votre prix pro',
      youSave: 'Vous économisez',
      delivery24h: 'Livraison 24h',
      returns14: 'Retours 14 jours',
      warranty2y: 'Garantie 2 ans',
      techSpecs: 'Caractéristiques techniques',
      packContent: 'Contenu du pack',
      packItems: ['Lunettes Joey Cyan', 'Étui pliable premium', 'Chiffon de nettoyage', 'Câble de charge', 'Manuel utilisateur'],
      base: 'base',
      lens: 'verres',
    },
    // Cart
    cartPage: {
      title: 'Mon Panier',
      continueShopping: 'Continuer vos achats',
      article: 'article',
      articles: 'articles',
      empty: 'Votre panier est vide',
      discoverCollection: 'Découvrir la collection',
      color: 'Couleur',
      lensOption: 'Verres',
      removed: 'Article supprimé',
      promoCode: 'Code promo',
      apply: 'Appliquer',
      promoRemoved: 'Code promo retiré',
      summary: 'Résumé',
      shippingMethod: 'Mode de livraison',
      noShipping: 'Aucun mode disponible',
      subtotalTTC: 'Sous-total TTC',
      discount: 'Réduction',
      shippingTTC: 'Livraison TTC',
      freeShipping: 'Gratuite',
      inclVAT: 'dont TVA (20%)',
      totalTTC: 'Total TTC',
      checkout: 'Finaliser la commande',
      securePayment: 'Paiement 100% sécurisé',
    },
    // Contact
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Une question sur nos lunettes ? Notre équipe est là pour vous répondre rapidement.',
      name: 'Nom',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      subject: 'Sujet',
      selectSubject: 'Sélectionnez un sujet',
      subjectProducts: 'Question sur les produits',
      subjectOrder: 'Suivi de commande',
      subjectSupport: 'Service après-vente',
      subjectPartnership: 'Partenariat Pro',
      subjectOther: 'Autre',
      message: 'Message',
      messagePlaceholder: 'Décrivez votre demande en détail...',
      send: 'Envoyer le message',
      sending: 'Envoi...',
      success: 'Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.',
      error: "Erreur lors de l'envoi du message. Veuillez réessayer.",
      emailCard: 'Email',
      emailDesc: 'Nous vous répondons sous 24h',
      whatsapp: 'WhatsApp',
      whatsappDesc: 'Discutez avec nous en temps réel',
      openWhatsapp: 'Ouvrir WhatsApp',
      phoneCard: 'Téléphone',
      phoneDesc: 'Du lundi au vendredi',
      sendMessage: 'Envoyez-nous un message',
      hours: 'Notre équipe est disponible du lundi au vendredi de 9h à 18h. Les messages reçus en dehors de ces horaires seront traités le jour ouvré suivant.',
    },
    // Profile
    profile: {
      title: 'Mon Profil',
      personalInfo: 'Informations personnelles',
      shippingAddress: 'Adresse de livraison',
      billingAddress: 'Adresse de facturation',
      changePassword: 'Changer le mot de passe',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      save: 'Enregistrer',
      saved: 'Profil mis à jour !',
    },
    // My Orders
    myOrders: {
      title: 'Mes commandes',
      noOrders: 'Aucune commande pour le moment.',
      orderNumber: 'Commande',
      date: 'Date',
      status: 'Statut',
      total: 'Total',
      details: 'Détails',
    },
    // About
    about: {
      title: 'À propos de Joey Cyan',
      subtitle: 'La vision du futur, aujourd\'hui.',
    },
    // Technology
    technology: {
      title: 'Notre Technologie',
      subtitle: 'Découvrez les innovations qui font de Joey Cyan un leader mondial.',
    },
    // Reviews
    reviewsPage: {
      title: 'Avis clients',
      subtitle: 'Ce que disent nos clients de leurs lunettes Joey Cyan.',
    },
    // Blog
    blogPage: {
      title: 'Blog',
      subtitle: 'Actualités, conseils et innovations dans le monde des lunettes connectées.',
      readMore: 'Lire la suite',
      allCategories: 'Tous',
      minRead: 'min de lecture',
      noPosts: 'Aucun article disponible.',
    },
    // Blog Post
    blogPost: {
      backToBlog: 'Retour au blog',
      share: 'Partager',
      relatedPosts: 'Articles similaires',
    },
    // Pro
    proPage: {
      title: 'Espace Professionnel',
      subtitle: 'Rejoignez notre réseau de revendeurs et bénéficiez de tarifs préférentiels.',
      companyName: 'Nom de l\'entreprise',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      siret: 'SIRET',
      activity: 'Secteur d\'activité',
      website: 'Site web',
      message: 'Message',
      submit: 'Envoyer ma demande',
      success: 'Demande envoyée avec succès !',
    },
    // Legal pages
    legal: {
      mentionsLegales: 'Mentions Légales',
      cgv: 'Conditions Générales de Vente',
      cgu: "Conditions Générales d'Utilisation",
      returnPolicy: 'Politique de Retour',
      privacyPolicy: 'Politique de Confidentialité',
      cookiePolicy: 'Politique des Cookies',
    },
    // Checkout success
    checkoutSuccess: {
      title: 'Commande confirmée !',
      thankYou: 'Merci pour votre commande',
      orderNumber: 'Numéro de commande',
      emailSent: 'Un email de confirmation vous a été envoyé.',
      continueShopping: 'Continuer mes achats',
      viewOrders: 'Voir mes commandes',
    },
    // Payment
    payment: {
      title: 'Paiement',
      processing: 'Traitement en cours...',
      success: 'Paiement réussi !',
      error: 'Erreur de paiement',
      thankYou: 'Merci pour votre achat !',
      orderConfirmed: 'Votre commande a été confirmée.',
      backToHome: "Retour à l'accueil",
    },
    // Common
    common: {
      loading: 'Chargement...',
      error: 'Erreur',
      save: 'Enregistrer',
      cancel: 'Annuler',
      close: 'Fermer',
      back: 'Retour',
      next: 'Suivant',
      previous: 'Précédent',
      search: 'Rechercher',
      yes: 'Oui',
      no: 'Non',
      free: 'Gratuit',
      hours: 'Horaires',
    },
  },

  en: {
    nav: {
      home: 'Home',
      optical: 'Optical',
      solar: 'Sunglasses',
      camera: 'Camera',
      smart: 'Smart',
      more: 'More',
      technology: 'Technology',
      reviews: 'Customer Reviews',
      about: 'About Us',
      faq: 'FAQ',
      blog: 'Blog',
      login: 'Login',
      pro: 'Pro',
      myProfile: 'My Profile',
      myOrders: 'My Orders',
      adminDashboard: 'Admin Dashboard',
      logout: 'Log Out',
      proAccount: 'Professional Account',
      collection: 'The Collection',
      contact: 'Contact',
    },
    banner: {
      connected: 'All our glasses are connected',
      details: '— Bluetooth, HeyCyan app, embedded AI',
      counterfeitTitle: 'Beware of counterfeits:',
      counterfeitText: 'many products imitating Joey Cyan circulate online. Purchase only on this official website to ensure authenticity and your safety.',
    },
    home: {
      leaderBadge: 'Leader in China · Now available in France',
      heroTitle1: 'See the',
      heroTitle2: 'future',
      heroTitle3: 'differently.',
      heroDesc: 'The #1 product in China finally arrives in France. Joey Cyan, AR connected glasses.',
      exploreCollection: 'Explore the collection',
      discoverTech: 'Discover the tech',
      clients: 'Customers',
      rating: 'Rating',
      china: 'China',
      countries: 'Countries',
      bestseller: 'Bestseller 2026',
      collectionTitle: 'Our flagship models',
      collectionLabel: 'Collection',
      seeAll: 'See all',
      noProducts: 'No products yet.',
      blueLight: 'Blue light filter',
      techTitle: 'Innovation within sight',
      techLabel: 'Technology',
      feat1Title: 'Total connectivity',
      feat1Desc: 'Built-in Bluetooth 5.3 & WiFi 6E.',
      feat2Title: 'Advanced AR',
      feat2Desc: 'Ultra-precise augmented reality.',
      feat3Title: '72h battery life',
      feat3Desc: 'Long-lasting battery.',
      feat4Title: 'Embedded AI',
      feat4Desc: 'Real-time translation.',
      testimonialsLabel: 'Testimonials',
      testimonialsTitle: 'Customer Reviews',
      testimonialsRating: '4.5 / 5 · +12,000 customers',
      ctaLabel: 'Ready to see the world differently?',
      ctaTitle: 'Discover our collection',
      ctaDesc: 'Free shipping. Returns within 14 days',
      ctaButton: 'Order now',
    },
    collection: {
      catalog: 'CATALOG',
      title: 'The Collection',
      all: 'All',
      search: 'Search...',
      sortNew: 'Newest',
      sortPriceAsc: 'Price: Low to High',
      sortPriceDesc: 'Price: High to Low',
      sortNameAsc: 'Name A-Z',
      noProducts: 'No products found.',
      noProductsDesc: 'Try changing your search criteria.',
    },
    product: {
      addToCart: 'Add to cart',
      addedToCart: 'Added to cart!',
      outOfStock: 'Out of stock',
      color: 'Color',
      lensOption: 'Lens configuration',
      features: 'Features',
      description: 'Description',
      reviews: 'Reviews',
      new: 'NEW',
      bestseller: 'BESTSELLER',
      freeShipping: 'Free shipping',
      returns: '14-day returns',
      warranty: '2-year warranty',
      inStock: 'In stock',
      quantity: 'Quantity',
      proPrice: 'Pro Price',
    },
    cart: {
      title: 'Your cart',
      empty: 'Your cart is empty',
      emptyDesc: 'Discover our collection of connected glasses.',
      continueShopping: 'Continue shopping',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      total: 'Total incl. tax',
      checkout: 'Proceed to checkout',
      remove: 'Remove',
      freeShipping: 'Free shipping',
      promoCode: 'Promo code',
      apply: 'Apply',
      loginForCart: 'Log in to save your cart',
    },
    auth: {
      loginTitle: 'Login',
      loginDesc: 'Access your Joey Cyan account',
      email: 'Email',
      password: 'Password',
      loginButton: 'Log in',
      noAccount: "Don't have an account?",
      signUp: 'Sign up',
      registerTitle: 'Create an account',
      registerDesc: 'Join the Joey Cyan community',
      name: 'Full name',
      confirmPassword: 'Confirm password',
      registerButton: 'Sign up',
      hasAccount: 'Already have an account?',
      loginLink: 'Log in',
      backToHome: 'Back to home',
      loginSuccess: 'Login successful!',
      registerSuccess: 'Account created successfully!',
    },
    footer: {
      description: 'Next-generation connected glasses. Camera, audio, embedded AI to see the future differently.',
      shop: 'Shop',
      opticalGlasses: 'Optical Glasses',
      solarGlasses: 'Sunglasses',
      cameraAR: 'Camera & AR',
      allCollection: 'Full collection',
      support: 'Support',
      returnsRefunds: 'Returns & Refunds',
      salesConditions: 'Terms of Sale',
      contact: 'Contact',
      blog: 'Blog',
      contactTitle: 'Contact',
      allRights: 'All rights reserved.',
      legalNotices: 'Legal Notices',
      cgv: 'TOS',
      cgu: 'TOU',
      privacy: 'Privacy',
      cookies: 'Cookies',
      manageCookies: 'Manage cookies',
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Find answers to your questions about our connected glasses.',
      noFaq: 'No FAQ available.',
      stillQuestions: 'Still have questions?',
      contactUs: 'Contact us',
    },
    contact: {
      title: 'Contact Us',
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send',
      sending: 'Sending...',
    },
    checkout: {
      title: 'Checkout',
      shipping: 'Shipping',
      payment: 'Payment',
      summary: 'Summary',
      shippingAddress: 'Shipping address',
      billingAddress: 'Billing address',
      differentBilling: 'Different billing address',
      firstName: 'First name',
      lastName: 'Last name',
      address: 'Address',
      postalCode: 'Postal code',
      city: 'City',
      country: 'Country',
      phone: 'Phone',
      shippingMethod: 'Shipping method',
      paymentMethod: 'Payment method',
      placeOrder: 'Place order',
    },
    cookie: {
      title: 'Cookies & Privacy',
      description: 'We use cookies to improve your experience. You can customize your preferences.',
      acceptAll: 'Accept all',
      reject: 'Reject',
      customize: 'Customize',
      learnMore: 'Learn more about cookies',
    },
    register: {
      title: 'Create an account',
      subtitle: 'Join the Joey Cyan community',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      minChars: 'Min. 6 characters',
      submit: 'Create my account',
      hasAccount: 'Already have an account?',
      login: 'Log in',
      backToHome: 'Back to home',
      success: 'Account created successfully!',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
    },
    productDetail: {
      backToCollection: 'Back to collection',
      notFound: 'Product not found.',
      color: 'Color',
      lensConfig: 'Lens configuration',
      notSelected: 'Not selected',
      included: 'Included',
      reimbursed: '100% Reimbursed',
      addToCart: 'Add to cart',
      addedToCart: 'Added to cart!',
      chooseLens: 'Please choose a lens option',
      publicPrice: 'Retail price',
      proPrice: 'Your pro price',
      youSave: 'You save',
      delivery24h: '24h delivery',
      returns14: '14-day returns',
      warranty2y: '2-year warranty',
      techSpecs: 'Technical specifications',
      packContent: 'Pack contents',
      packItems: ['Joey Cyan glasses', 'Premium folding case', 'Cleaning cloth', 'Charging cable', 'User manual'],
      base: 'base',
      lens: 'lens',
    },
    cartPage: {
      title: 'My Cart',
      continueShopping: 'Continue shopping',
      article: 'item',
      articles: 'items',
      empty: 'Your cart is empty',
      discoverCollection: 'Discover the collection',
      color: 'Color',
      lensOption: 'Lens',
      removed: 'Item removed',
      promoCode: 'Promo code',
      apply: 'Apply',
      promoRemoved: 'Promo code removed',
      summary: 'Summary',
      shippingMethod: 'Shipping method',
      noShipping: 'No method available',
      subtotalTTC: 'Subtotal incl. tax',
      discount: 'Discount',
      shippingTTC: 'Shipping incl. tax',
      freeShipping: 'Free',
      inclVAT: 'incl. VAT (20%)',
      totalTTC: 'Total incl. tax',
      checkout: 'Proceed to checkout',
      securePayment: '100% secure payment',
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Have a question about our glasses? Our team is here to help.',
      name: 'Name',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      selectSubject: 'Select a subject',
      subjectProducts: 'Product question',
      subjectOrder: 'Order tracking',
      subjectSupport: 'After-sales service',
      subjectPartnership: 'Pro partnership',
      subjectOther: 'Other',
      message: 'Message',
      messagePlaceholder: 'Describe your request in detail...',
      send: 'Send message',
      sending: 'Sending...',
      success: 'Message sent successfully! We will respond shortly.',
      error: 'Error sending message. Please try again.',
      emailCard: 'Email',
      emailDesc: 'We respond within 24h',
      whatsapp: 'WhatsApp',
      whatsappDesc: 'Chat with us in real time',
      openWhatsapp: 'Open WhatsApp',
      phoneCard: 'Phone',
      phoneDesc: 'Monday to Friday',
      sendMessage: 'Send us a message',
      hours: 'Our team is available Monday to Friday from 9am to 6pm. Messages received outside these hours will be processed the next business day.',
    },
    profile: {
      title: 'My Profile',
      personalInfo: 'Personal information',
      shippingAddress: 'Shipping address',
      billingAddress: 'Billing address',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      save: 'Save',
      saved: 'Profile updated!',
    },
    myOrders: {
      title: 'My Orders',
      noOrders: 'No orders yet.',
      orderNumber: 'Order',
      date: 'Date',
      status: 'Status',
      total: 'Total',
      details: 'Details',
    },
    about: {
      title: 'About Joey Cyan',
      subtitle: 'The vision of the future, today.',
    },
    technology: {
      title: 'Our Technology',
      subtitle: 'Discover the innovations that make Joey Cyan a global leader.',
    },
    reviewsPage: {
      title: 'Customer Reviews',
      subtitle: 'What our customers say about their Joey Cyan glasses.',
    },
    blogPage: {
      title: 'Blog',
      subtitle: 'News, tips and innovations in the world of connected glasses.',
      readMore: 'Read more',
      allCategories: 'All',
      minRead: 'min read',
      noPosts: 'No articles available.',
    },
    blogPost: {
      backToBlog: 'Back to blog',
      share: 'Share',
      relatedPosts: 'Related articles',
    },
    proPage: {
      title: 'Professional Area',
      subtitle: 'Join our reseller network and benefit from preferential rates.',
      companyName: 'Company name',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      siret: 'SIRET',
      activity: 'Industry',
      website: 'Website',
      message: 'Message',
      submit: 'Send my request',
      success: 'Request sent successfully!',
    },
    legal: {
      mentionsLegales: 'Legal Notices',
      cgv: 'Terms and Conditions of Sale',
      cgu: 'Terms of Use',
      returnPolicy: 'Return Policy',
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
    },
    checkoutSuccess: {
      title: 'Order confirmed!',
      thankYou: 'Thank you for your order',
      orderNumber: 'Order number',
      emailSent: 'A confirmation email has been sent to you.',
      continueShopping: 'Continue shopping',
      viewOrders: 'View my orders',
    },
    payment: {
      title: 'Payment',
      processing: 'Processing...',
      success: 'Payment successful!',
      error: 'Payment error',
      thankYou: 'Thank you for your purchase!',
      orderConfirmed: 'Your order has been confirmed.',
      backToHome: 'Back to home',
    },
    common: {
      loading: 'Loading...',
      error: 'Error',
      save: 'Save',
      cancel: 'Cancel',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      search: 'Search',
      yes: 'Yes',
      no: 'No',
      free: 'Free',
      hours: 'Hours',
    },
  },

  de: {
    nav: {
      home: 'Startseite',
      optical: 'Optisch',
      solar: 'Sonnenbrillen',
      camera: 'Kamera',
      smart: 'Smart',
      more: 'Mehr',
      technology: 'Technologie',
      reviews: 'Kundenbewertungen',
      about: 'Über uns',
      faq: 'FAQ',
      blog: 'Blog',
      login: 'Anmelden',
      pro: 'Pro',
      myProfile: 'Mein Profil',
      myOrders: 'Meine Bestellungen',
      adminDashboard: 'Admin Dashboard',
      logout: 'Abmelden',
      proAccount: 'Geschäftskonto',
      collection: 'Die Kollektion',
      contact: 'Kontakt',
    },
    banner: {
      connected: 'Alle unsere Brillen sind vernetzt',
      details: '— Bluetooth, HeyCyan-App, integrierte KI',
      counterfeitTitle: 'Vorsicht vor Fälschungen:',
      counterfeitText: 'Im Internet sind zahlreiche Produkte im Umlauf, die Joey Cyan imitieren. Kaufen Sie ausschließlich auf dieser offiziellen Website, um Echtheit und Sicherheit zu gewährleisten.',
    },
    home: {
      leaderBadge: 'Marktführer in China · Jetzt in Frankreich erhältlich',
      heroTitle1: 'Sehen Sie die',
      heroTitle2: 'Zukunft',
      heroTitle3: 'anders.',
      heroDesc: 'Das Produkt Nr. 1 in China kommt endlich nach Europa. Joey Cyan, AR-vernetzte Brillen.',
      exploreCollection: 'Kollektion entdecken',
      discoverTech: 'Technologie entdecken',
      clients: 'Kunden',
      rating: 'Bewertung',
      china: 'China',
      countries: 'Länder',
      bestseller: 'Bestseller 2026',
      collectionTitle: 'Unsere Top-Modelle',
      collectionLabel: 'Kollektion',
      seeAll: 'Alle anzeigen',
      noProducts: 'Noch keine Produkte.',
      blueLight: 'Blaulichtfilter',
      techTitle: 'Innovation in Sichtweite',
      techLabel: 'Technologie',
      feat1Title: 'Volle Konnektivität',
      feat1Desc: 'Integriertes Bluetooth 5.3 & WiFi 6E.',
      feat2Title: 'Fortschrittliche AR',
      feat2Desc: 'Hochpräzise erweiterte Realität.',
      feat3Title: '72 Std. Akkulaufzeit',
      feat3Desc: 'Langlebiger Akku.',
      feat4Title: 'Integrierte KI',
      feat4Desc: 'Echtzeit-Übersetzung.',
      testimonialsLabel: 'Erfahrungsberichte',
      testimonialsTitle: 'Kundenbewertungen',
      testimonialsRating: '4,5 / 5 · +12.000 Kunden',
      ctaLabel: 'Bereit, die Welt anders zu sehen?',
      ctaTitle: 'Entdecken Sie unsere Kollektion',
      ctaDesc: 'Kostenloser Versand. Rückgabe innerhalb 14 Tagen',
      ctaButton: 'Jetzt bestellen',
    },
    collection: {
      catalog: 'KATALOG',
      title: 'Die Kollektion',
      all: 'Alle',
      search: 'Suchen...',
      sortNew: 'Neuheiten',
      sortPriceAsc: 'Preis: aufsteigend',
      sortPriceDesc: 'Preis: absteigend',
      sortNameAsc: 'Name A-Z',
      noProducts: 'Keine Produkte gefunden.',
      noProductsDesc: 'Versuchen Sie, Ihre Suchkriterien zu ändern.',
    },
    product: {
      addToCart: 'In den Warenkorb',
      addedToCart: 'Zum Warenkorb hinzugefügt!',
      outOfStock: 'Nicht auf Lager',
      color: 'Farbe',
      lensOption: 'Gläser-Konfiguration',
      features: 'Eigenschaften',
      description: 'Beschreibung',
      reviews: 'Bewertungen',
      new: 'NEU',
      bestseller: 'BESTSELLER',
      freeShipping: 'Kostenloser Versand',
      returns: '14 Tage Rückgabe',
      warranty: '2 Jahre Garantie',
      inStock: 'Auf Lager',
      quantity: 'Menge',
      proPrice: 'Pro-Preis',
    },
    cart: {
      title: 'Ihr Warenkorb',
      empty: 'Ihr Warenkorb ist leer',
      emptyDesc: 'Entdecken Sie unsere Kollektion vernetzter Brillen.',
      continueShopping: 'Weiter einkaufen',
      subtotal: 'Zwischensumme',
      shipping: 'Versand',
      total: 'Gesamtbetrag inkl. MwSt.',
      checkout: 'Zur Kasse',
      remove: 'Entfernen',
      freeShipping: 'Kostenloser Versand',
      promoCode: 'Gutscheincode',
      apply: 'Anwenden',
      loginForCart: 'Melden Sie sich an, um Ihren Warenkorb zu speichern',
    },
    auth: {
      loginTitle: 'Anmelden',
      loginDesc: 'Zugang zu Ihrem Joey Cyan Konto',
      email: 'E-Mail',
      password: 'Passwort',
      loginButton: 'Anmelden',
      noAccount: 'Noch kein Konto?',
      signUp: 'Registrieren',
      registerTitle: 'Konto erstellen',
      registerDesc: 'Werden Sie Teil der Joey Cyan Community',
      name: 'Vollständiger Name',
      confirmPassword: 'Passwort bestätigen',
      registerButton: 'Registrieren',
      hasAccount: 'Bereits ein Konto?',
      loginLink: 'Anmelden',
      backToHome: 'Zurück zur Startseite',
      loginSuccess: 'Anmeldung erfolgreich!',
      registerSuccess: 'Konto erfolgreich erstellt!',
      forgotPassword: 'Passwort vergessen?',
      forgotPasswordTitle: 'Passwort vergessen',
      forgotPasswordDesc: 'Geben Sie Ihre E-Mail ein, wir senden Ihnen ein neues Passwort.',
      forgotPasswordButton: 'Zurücksetzen',
      forgotPasswordSuccess: 'Wenn ein Konto mit dieser E-Mail existiert, wurde ein neues Passwort gesendet.',
      forgotPasswordBack: 'Zurück zur Anmeldung',
    },
    footer: {
      description: 'Vernetzte Brillen der nächsten Generation. Kamera, Audio, integrierte KI – die Zukunft anders sehen.',
      shop: 'Shop',
      opticalGlasses: 'Optische Brillen',
      solarGlasses: 'Sonnenbrillen',
      cameraAR: 'Kamera & AR',
      allCollection: 'Gesamte Kollektion',
      support: 'Support',
      returnsRefunds: 'Rückgaben & Erstattungen',
      salesConditions: 'Verkaufsbedingungen',
      contact: 'Kontakt',
      blog: 'Blog',
      contactTitle: 'Kontakt',
      allRights: 'Alle Rechte vorbehalten.',
      legalNotices: 'Impressum',
      cgv: 'AGB',
      cgu: 'Nutzungsbedingungen',
      privacy: 'Datenschutz',
      cookies: 'Cookies',
      manageCookies: 'Cookies verwalten',
    },
    faq: {
      title: 'Häufig gestellte Fragen',
      subtitle: 'Finden Sie Antworten zu unseren vernetzten Brillen.',
      noFaq: 'Keine FAQ verfügbar.',
      stillQuestions: 'Haben Sie noch Fragen?',
      contactUs: 'Kontaktieren Sie uns',
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      name: 'Name',
      email: 'E-Mail',
      subject: 'Betreff',
      message: 'Nachricht',
      send: 'Senden',
      sending: 'Wird gesendet...',
    },
    checkout: {
      title: 'Bestellung',
      shipping: 'Versand',
      payment: 'Zahlung',
      summary: 'Zusammenfassung',
      shippingAddress: 'Lieferadresse',
      billingAddress: 'Rechnungsadresse',
      differentBilling: 'Andere Rechnungsadresse',
      firstName: 'Vorname',
      lastName: 'Nachname',
      address: 'Adresse',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      country: 'Land',
      phone: 'Telefon',
      shippingMethod: 'Versandart',
      paymentMethod: 'Zahlungsmethode',
      placeOrder: 'Bestellung aufgeben',
    },
    cookie: {
      title: 'Cookies & Datenschutz',
      description: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern. Sie können Ihre Einstellungen anpassen.',
      acceptAll: 'Alle akzeptieren',
      reject: 'Ablehnen',
      customize: 'Anpassen',
      learnMore: 'Mehr über Cookies erfahren',
    },
    register: {
      title: 'Konto erstellen',
      subtitle: 'Werden Sie Teil der Joey Cyan Community',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      minChars: 'Min. 6 Zeichen',
      submit: 'Konto erstellen',
      hasAccount: 'Bereits ein Konto?',
      login: 'Anmelden',
      backToHome: 'Zurück zur Startseite',
      success: 'Konto erfolgreich erstellt!',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      passwordTooShort: 'Das Passwort muss mindestens 6 Zeichen lang sein',
    },
    productDetail: {
      backToCollection: 'Zurück zur Kollektion',
      notFound: 'Produkt nicht gefunden.',
      color: 'Farbe',
      lensConfig: 'Gläser-Konfiguration',
      notSelected: 'Nicht ausgewählt',
      included: 'Inklusive',
      reimbursed: '100% Erstattet',
      addToCart: 'In den Warenkorb',
      addedToCart: 'In den Warenkorb gelegt!',
      chooseLens: 'Bitte wählen Sie eine Glasoption',
      publicPrice: 'Öffentlicher Preis',
      proPrice: 'Ihr Pro-Preis',
      youSave: 'Sie sparen',
      delivery24h: '24-Std-Lieferung',
      returns14: '14 Tage Rückgabe',
      warranty2y: '2 Jahre Garantie',
      techSpecs: 'Technische Daten',
      packContent: 'Packungsinhalt',
      packItems: ['Joey Cyan Brille', 'Faltbares Premium-Etui', 'Reinigungstuch', 'Ladekabel', 'Benutzerhandbuch'],
      base: 'Basis',
      lens: 'Gläser',
    },
    cartPage: {
      title: 'Mein Warenkorb',
      continueShopping: 'Weiter einkaufen',
      article: 'Artikel',
      articles: 'Artikel',
      empty: 'Ihr Warenkorb ist leer',
      discoverCollection: 'Kollektion entdecken',
      color: 'Farbe',
      lensOption: 'Gläser',
      removed: 'Artikel entfernt',
      promoCode: 'Gutscheincode',
      apply: 'Anwenden',
      promoRemoved: 'Gutscheincode entfernt',
      summary: 'Zusammenfassung',
      shippingMethod: 'Versandart',
      noShipping: 'Keine Methode verfügbar',
      subtotalTTC: 'Zwischensumme inkl. MwSt.',
      discount: 'Rabatt',
      shippingTTC: 'Versand inkl. MwSt.',
      freeShipping: 'Kostenlos',
      inclVAT: 'inkl. MwSt. (20%)',
      totalTTC: 'Gesamt inkl. MwSt.',
      checkout: 'Zur Kasse',
      securePayment: '100% sichere Zahlung',
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Haben Sie eine Frage zu unseren Brillen? Unser Team hilft Ihnen gerne.',
      name: 'Name',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      subject: 'Betreff',
      selectSubject: 'Betreff auswählen',
      subjectProducts: 'Produktfrage',
      subjectOrder: 'Bestellverfolgung',
      subjectSupport: 'Kundendienst',
      subjectPartnership: 'Pro-Partnerschaft',
      subjectOther: 'Sonstiges',
      message: 'Nachricht',
      messagePlaceholder: 'Beschreiben Sie Ihre Anfrage im Detail...',
      send: 'Nachricht senden',
      sending: 'Wird gesendet...',
      success: 'Nachricht erfolgreich gesendet! Wir werden in Kürze antworten.',
      error: 'Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.',
      emailCard: 'E-Mail',
      emailDesc: 'Wir antworten innerhalb von 24 Stunden',
      whatsapp: 'WhatsApp',
      whatsappDesc: 'Chatten Sie mit uns in Echtzeit',
      openWhatsapp: 'WhatsApp öffnen',
      phoneCard: 'Telefon',
      phoneDesc: 'Montag bis Freitag',
      sendMessage: 'Senden Sie uns eine Nachricht',
      hours: 'Unser Team ist montags bis freitags von 9 bis 18 Uhr erreichbar. Nachrichten außerhalb dieser Zeiten werden am nächsten Werktag bearbeitet.',
    },
    profile: {
      title: 'Mein Profil',
      personalInfo: 'Persönliche Daten',
      shippingAddress: 'Lieferadresse',
      billingAddress: 'Rechnungsadresse',
      changePassword: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      save: 'Speichern',
      saved: 'Profil aktualisiert!',
    },
    myOrders: {
      title: 'Meine Bestellungen',
      noOrders: 'Noch keine Bestellungen.',
      orderNumber: 'Bestellung',
      date: 'Datum',
      status: 'Status',
      total: 'Gesamt',
      details: 'Details',
    },
    about: {
      title: 'Über Joey Cyan',
      subtitle: 'Die Vision der Zukunft, heute.',
    },
    technology: {
      title: 'Unsere Technologie',
      subtitle: 'Entdecken Sie die Innovationen, die Joey Cyan zum Weltmarktführer machen.',
    },
    reviewsPage: {
      title: 'Kundenbewertungen',
      subtitle: 'Was unsere Kunden über ihre Joey Cyan Brillen sagen.',
    },
    blogPage: {
      title: 'Blog',
      subtitle: 'Neuigkeiten, Tipps und Innovationen in der Welt der vernetzten Brillen.',
      readMore: 'Weiterlesen',
      allCategories: 'Alle',
      minRead: 'Min. Lesezeit',
      noPosts: 'Keine Artikel verfügbar.',
    },
    blogPost: {
      backToBlog: 'Zurück zum Blog',
      share: 'Teilen',
      relatedPosts: 'Ähnliche Artikel',
    },
    proPage: {
      title: 'Geschäftsbereich',
      subtitle: 'Treten Sie unserem Händlernetzwerk bei und profitieren Sie von Vorzugspreisen.',
      companyName: 'Firmenname',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      siret: 'SIRET',
      activity: 'Branche',
      website: 'Webseite',
      message: 'Nachricht',
      submit: 'Anfrage senden',
      success: 'Anfrage erfolgreich gesendet!',
    },
    legal: {
      mentionsLegales: 'Impressum',
      cgv: 'Allgemeine Geschäftsbedingungen',
      cgu: 'Nutzungsbedingungen',
      returnPolicy: 'Rückgaberichtlinie',
      privacyPolicy: 'Datenschutzrichtlinie',
      cookiePolicy: 'Cookie-Richtlinie',
    },
    checkoutSuccess: {
      title: 'Bestellung bestätigt!',
      thankYou: 'Vielen Dank für Ihre Bestellung',
      orderNumber: 'Bestellnummer',
      emailSent: 'Eine Bestätigungsmail wurde an Sie gesendet.',
      continueShopping: 'Weiter einkaufen',
      viewOrders: 'Meine Bestellungen ansehen',
    },
    payment: {
      title: 'Zahlung',
      processing: 'Verarbeitung...',
      success: 'Zahlung erfolgreich!',
      error: 'Zahlungsfehler',
      thankYou: 'Vielen Dank für Ihren Einkauf!',
      orderConfirmed: 'Ihre Bestellung wurde bestätigt.',
      backToHome: 'Zurück zur Startseite',
    },
    common: {
      loading: 'Laden...',
      error: 'Fehler',
      save: 'Speichern',
      cancel: 'Abbrechen',
      close: 'Schließen',
      back: 'Zurück',
      next: 'Weiter',
      previous: 'Zurück',
      search: 'Suchen',
      yes: 'Ja',
      no: 'Nein',
      free: 'Kostenlos',
      hours: 'Öffnungszeiten',
    },
  },
};

const FLAGS = {
  fr: '🇫🇷',
  en: '🇬🇧',
  de: '🇩🇪',
};

const LANG_LABELS = {
  fr: 'FR',
  en: 'EN',
  de: 'DE',
};

// Dynamic content translations (categories, FAQ categories, blog categories)
const contentTranslations = {
  en: {
    // Product categories
    'Optique': 'Optical',
    'Solaire': 'Sunglasses',
    'Caméra': 'Camera',
    'Smart': 'Smart',
    'Tous': 'All',
    // FAQ categories
    'Commande': 'Orders',
    'Livraison': 'Shipping',
    'Produit': 'Product',
    'Retours & Garantie': 'Returns & Warranty',
    'Général': 'General',
    // Blog categories
    'Conseils': 'Tips',
    'Technologie': 'Technology',
    'Actualités': 'News',
    'Style': 'Style',
    'Santé visuelle': 'Eye Health',
    'Guide utilisation': 'User Guide',
    // Product subtitles
    'Lunettes optiques connectées': 'Connected optical glasses',
    'Lunettes solaires connectées': 'Connected sunglasses',
    'Lunettes caméra connectées': 'Connected camera glasses',
    'Lunettes smart connectées': 'Connected smart glasses',
    // Common labels
    'optique': 'optical',
    'solaire': 'sunglasses',
    'camera': 'camera',
    'smart': 'smart',
  },
  de: {
    'Optique': 'Optisch',
    'Solaire': 'Sonnenbrillen',
    'Caméra': 'Kamera',
    'Smart': 'Smart',
    'Tous': 'Alle',
    'Commande': 'Bestellungen',
    'Livraison': 'Lieferung',
    'Produit': 'Produkt',
    'Retours & Garantie': 'Rückgabe & Garantie',
    'Général': 'Allgemein',
    'Conseils': 'Tipps',
    'Technologie': 'Technologie',
    'Actualités': 'Neuigkeiten',
    'Style': 'Stil',
    'Santé visuelle': 'Augengesundheit',
    'Guide utilisation': 'Benutzerhandbuch',
    'Lunettes optiques connectées': 'Vernetzte optische Brillen',
    'Lunettes solaires connectées': 'Vernetzte Sonnenbrillen',
    'Lunettes caméra connectées': 'Vernetzte Kamerabrillen',
    'Lunettes smart connectées': 'Vernetzte Smart-Brillen',
    'optique': 'optisch',
    'solaire': 'sonnenbrillen',
    'camera': 'kamera',
    'smart': 'smart',
  },
};

function detectBrowserLanguage() {
  const browserLang = navigator.language || navigator.userLanguage || 'fr';
  const lang = browserLang.split('-')[0].toLowerCase();
  if (['fr', 'en', 'de'].includes(lang)) return lang;
  // Default to English for non-FR/DE speakers
  if (lang !== 'fr') return 'en';
  return 'fr';
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem('jc_language');
    if (stored) return stored;
    // First visit: detect browser language
    const detected = detectBrowserLanguage();
    localStorage.setItem('jc_language', detected);
    return detected;
  });

  useEffect(() => {
    localStorage.setItem('jc_language', language);
    // Keep <html lang="fr"> always for SEO consistency.
    // Site canonical content + meta tags are in French regardless of UI language.
    document.documentElement.lang = 'fr';
  }, [language]);

  // t('nav.home') => returns translated string
  const t = (key) => {
    const keys = key.split('.');
    let result = translations[language];
    for (const k of keys) {
      if (result && typeof result === 'object' && k in result) {
        result = result[k];
      } else {
        // Fallback to French
        let fallback = translations['fr'];
        for (const fk of keys) {
          if (fallback && typeof fallback === 'object' && fk in fallback) {
            fallback = fallback[fk];
          } else {
            return key; // Return key if nothing found
          }
        }
        return fallback;
      }
    }
    return result;
  };

  // tc('Optique') => translates dynamic DB content (categories, labels)
  const tc = (text) => {
    if (!text || language === 'fr') return text;
    return contentTranslations[language]?.[text] || text;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, tc, FLAGS, LANG_LABELS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
